var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCinema = function SvgCinema(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15.6 18.6v-6m0 0v-3m0 3h5m-5-12v9m0 0h-10m10-3h5m-15 12v-6m0-12v12m0 0h-5m5-6h-5m3 12h14a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3h-14a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3"
  })));
};
export default SvgCinema;